import { render, staticRenderFns } from "./mbContract.vue?vue&type=template&id=77c3e20e&scoped=true&"
import script from "./mbContract.vue?vue&type=script&lang=js&"
export * from "./mbContract.vue?vue&type=script&lang=js&"
import style0 from "./mbContract.vue?vue&type=style&index=0&id=77c3e20e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c3e20e",
  null
  
)

export default component.exports